<template>
  <div class="preview-interface">
    <P5
      v-show="selected != 'vr'"
      :sketch="sketch2"
      :params="sketchData"
      class="preview-sketch"
    ></P5>
    <VrPlayer
      v-if="selected === 'vr'"
      class="vr-player"
      :img="p5Data.id"
      :lcoords="p5Data.lcoords"
      :rcoords="p5Data.rcoords"
    ></VrPlayer>

    <div class="preview-links">
      <a
        id="flicker-preview"
        href="#"
        :class="{ selected: selected == 'flicker' }"
        @click.prevent="updateRoute('flicker')"
      >
        View Flicker GIF
      </a>
      |
      <a
        id="cross-eye-preview"
        :class="{ selected: selected == 'crossed' }"
        href="#"
        @click.prevent="updateRoute('crossed')"
      >
        View Cross-eyed
      </a>
      |
      <a
        id="vr-preview"
        :class="{ selected: selected == 'vr' }"
        href="#"
        @click.prevent="updateRoute('vr')"
        >View in VR
      </a>
    </div>
  </div>
</template>

<script>
import _sketch2 from "@/libs/thumb-sketch.js";
import P5 from "@/components/P5.vue";
import VrPlayer from "@/components/VrPlayer.vue";

export default {
  name: "PreviewBox",
  components: {
    P5,
    VrPlayer,
  },
  methods: {
    sketch2: _sketch2,
    updateRoute: function (val) {
      // Make a clean copy of the current query
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.p = val;
      this.$router.replace({ query: queries });
    },
  },
  computed: {
    showFlicker: function () {
      return this.selected == "flicker";
    },
    sketchData: function () {
      let data = {
        l: this.p5Data.l,
        r: this.p5Data.r,
        showFlicker: this.showFlicker,
      };
      return data;
    },
  },
  props: {
    p5Data: {
      type: Object,
    },
    selected: {
      type: String,
      default: "flicker",
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.preview-interface {
  grid-column: 3 / 4;
  @include interface-box;
}

.preview-sketch {
  text-align: center;
}

.preview-links {
  @include label-border;
  font-size: 90%;
  text-align: right;
}
.vr-player {
  width: 100%;
  height: 250px;
}
</style>
